module.exports = __webpack_public_path__ + "media/images/pic/meat-and-rosemary-b1258e4834540a50907df3e33176895b.webp";